import { render, staticRenderFns } from "./BaseConfirm.vue?vue&type=template&id=11af1846&scoped=true&"
import script from "./BaseConfirm.vue?vue&type=script&lang=js&"
export * from "./BaseConfirm.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfirm.vue?vue&type=style&index=0&id=11af1846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11af1846",
  null
  
)

export default component.exports